if (isNullOrUndefined(sumo)) {
    throw ('Geo.js requies the sumo namespace defined in sumoClass.js');
}

if (isNullOrUndefined(sumo.geo)) {
    sumo.geo = {};                  //geo namespace
}

sumo.geo.Point = function (aLatitude, aLongitude) {
    "use strict";

    this.Latitude = aLatitude;
    this.Longitude = aLongitude;
};
sumo.geo.Point.prototype = new sumo.Class();
sumo.geo.Point.prototype.constructor = sumo.geo.Point;
sumo.geo.Point.prototype.baseClass = sumo.Class;

sumo.geo.conversion = {};               //conversion namespace


// 364566.9294 feet per degree lat
// 6076.11549 feet per minute
sumo.geo.conversion.feetToDegreeLatitude = function (aFeet) {
    "use strict";
    var lFeetPerDegree = 364566.9294;
    return aFeet / lFeetPerDegree;
};

sumo.geo.conversion.toRadians = function (aDegrees) {
    "use strict";
    return aDegrees * (Math.PI / 180.0);
};

sumo.geo.conversion.toDegrees = function (aRadians) {
    "use strict";
    return (180.0 / Math.PI) * aRadians;
};

sumo.geo.conversion.nauticalMilesToStatuteMiles = function (aNauticalMiles) {
    "use strict";
    return 1.150779449 * aNauticalMiles;
};

sumo.geo.conversion.statuteMilesToNauticalMiles = function (aStatuteMiles) {
    "use strict";
    return aStatuteMiles / 1.150779449;
};

sumo.geo.conversion.statuteMilesToFeet = function (aStatuteMiles) {
    "use strict";
    return aStatuteMiles * 5280;
};

sumo.geo.conversion.feetToStatuteMiles = function (aFeet) {
    "use strict";
    return aFeet / 5280;
};

sumo.geo.conversion.feetToNauticalMiles = function (aFeet) {
    "use strict";
    return aFeet / 6076.11549;
};

sumo.geo.conversion.nauticalMilesToFeet = function (aNauticalMiles) {
    "use strict";
    return aNauticalMiles * 6076.11549;
};

sumo.geo.conversion.feetToMeters = function (aFeet) {
    "use strict";
    return aFeet * 0.3048;
};

sumo.geo.conversion.feetToKilometers = function (aFeet) {
    "use strict";
    return aFeet * 0.3048 / 1000;
};

sumo.geo.conversion.metersToFeet = function (aMeters) {
    "use strict";
    return aMeters / 0.3048;
};

sumo.geo.conversion.degreesLatitudePerNM = function (aLatitude) {
    "use strict";
    throw ('not implemented');
    // vb code in comments below to implement this function if required
};

sumo.geo.conversion.degreesLongitudePerNM = function (aLatitude) {
    "use strict";
    throw ('not implemented');
    // vb code in comments below to implement this function if required
};

sumo.geo.conversion.metersToNauticalMiles = function (aMeters) {
    "use strict";
    var lFeet = sumo.geo.conversion.metersToFeet(aMeters);
    return sumo.geo.conversion.feetToNauticalMiles(lFeet);
};

sumo.geo.conversion.kilometersToNauticalMiles = function (aKilometers) {
    "use strict";   
    return aKilometers * 0.539956804;
};